import { render, staticRenderFns } from "./FilterSearchResetButton.vue?vue&type=template&id=63700654&"
import script from "./FilterSearchResetButton.vue?vue&type=script&lang=js&"
export * from "./FilterSearchResetButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports